<div class="fade-in">
  <div class="content-section">
    <div class="section-header">
      <h2>Owner Management</h2>
      <button class="primary-btn" (click)="openAddModal()">+ Add Owner</button>
    </div>

    <!-- Modal Form for Add/Edit -->
    <div class="modal-overlay" *ngIf="isModalOpen">
      <div class="modal-content fade-in" [class.saving-mode]="isSaving">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
          <h3 class="modal-title" style="margin-bottom: 0;">
            {{ editingId ? 'Edit Owner' : 'Add New Owner' }}
          </h3>
          <div style="display: flex; align-items: center; gap: 8px;">
            <input type="checkbox" id="showTotalDist" [(ngModel)]="newOwner.showTotalDistribution" [disabled]="isSaving" style="width: 16px; height: 16px; accent-color: #2563eb; cursor: pointer; margin: 0;">
            <label for="showTotalDist" style="font-size: 0.9rem; font-weight: 600; color: #334155; cursor: pointer; margin: 0;">Show Total Distribution</label>
          </div>
        </div>
        
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin-bottom: 20px;">
          <div class="form-group">
            <label style="display: block; font-size: 0.85rem; font-weight: 600; color: #64748b; margin-bottom: 6px;">Name *</label>
            <input [(ngModel)]="newOwner.name" [disabled]="isSaving" placeholder="Owner Name" style="width: 100%; padding: 8px 12px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.95rem;">
          </div>
          <div class="form-group">
            <label style="display: block; font-size: 0.85rem; font-weight: 600; color: #64748b; margin-bottom: 6px;">Email *</label>
            <input [(ngModel)]="newOwner.email" [disabled]="isSaving" placeholder="owner@example.com" style="width: 100%; padding: 8px 12px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.95rem;">
          </div>
          <div class="form-group">
            <label style="display: block; font-size: 0.85rem; font-weight: 600; color: #64748b; margin-bottom: 6px;">Phone</label>
            <input [(ngModel)]="newOwner.phone" [disabled]="isSaving" placeholder="(555) 123-4567" style="width: 100%; padding: 8px 12px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.95rem;">
          </div>
        </div>

        <div class="modal-actions">
          <button class="secondary-btn" (click)="cancelEdit()" [disabled]="isSaving">Cancel</button>
          <button class="primary-btn" (click)="saveOwner()" [disabled]="isSaving">
            <span *ngIf="isSaving" class="spinner-small"></span>
            <span>{{ editingId ? 'Update Owner' : 'Add Owner' }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Owner List Table -->
    <div class="table-container">
      <table class="ledger-table" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr style="border-bottom: 2px solid #e2e8f0; text-align: left;">
            <th style="padding: 12px;">Name</th>
            <th style="padding: 12px;">Email</th>
            <th style="padding: 12px;">Phone</th>
            <th class="text-center" style="padding: 12px; text-align: center;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let owner of owners$ | async" style="border-bottom: 1px solid #f1f5f9;">
            <td style="padding: 12px; font-weight: 600; color: #334155;">{{ owner.name }}</td>
            <td style="padding: 12px; color: #475569;">{{ owner.email }}</td>
            <td style="padding: 12px; color: #475569;">{{ owner.phone }}</td>
            <td class="text-center" style="padding: 12px; text-align: center;">
              <button class="icon-btn" (click)="editOwner(owner)" title="Edit" style="border:none; background:none; cursor:pointer; margin-right: 8px; font-size: 1.1rem;">✏️</button>
              <button class="icon-btn" (click)="deleteOwner(owner.id)" title="Delete" style="border:none; background:none; cursor:pointer; font-size: 1.1rem;">🗑️</button>
            </td>
          </tr>
          <tr *ngIf="(owners$ | async)?.length === 0">
            <td colspan="4" style="text-align: center; padding: 40px; color: #94a3b8;">
              No owners found. Add a new owner above.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>